import { render, staticRenderFns } from "./SkupTema2Forma.vue?vue&type=template&id=0c36246b&scoped=true&"
import script from "./SkupTema2Forma.vue?vue&type=script&lang=js&"
export * from "./SkupTema2Forma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c36246b",
  null
  
)

export default component.exports